<template>
    <button class="toggle-collapse">
        <b-icon 
            icon="camera" 
            :class="{rotated:isRotated}"
            @click="!isRotated ? rotateIcon() : false">
        </b-icon>
        <!-- <b-icon icon="camera" rotate="-45"></b-icon> -->
    </button>
</template>

<script>
    export default {
        data: () => ({
            isRotated: false,
        }),
        methods: {
            rotateIcon() {
                this.isRotated = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .rotated {
        transform: rotate(-45deg);
    }
</style>
